// extracted by mini-css-extract-plugin
module.exports = {"item":"LinkedProductItem_item__7LJ40","initialSelected":"LinkedProductItem_initialSelected__xsKRF","image":"LinkedProductItem_image__aWD63"};